import Input from "../Components/Modal/Input";
import { Modal } from "react-bootstrap";
import "../Styles/Modal.css";
import PasswordInput from "../Components/Modal/PasswordInput";
import { ButtonContainer } from "../Components/Shared/ButtonComponent";
import Checkbox from "@mui/material/Checkbox";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../hooks/useAuth";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { UserContext } from "../context/userContext";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const SignInBox = ({ setForgetPasswordModal, setModalShow }) => {
  return (
    <div className="todo-list">
      <span className="todo-item">
        <Checkbox
          sx={{
            color: "",
            "&.Mui-checked": {
              color: " #bc9a43",
            },
          }}
          {...label}
        />

        <span className="check-item">Remember me</span>
      </span>

      <span>
        <button
        type="button"
          onClick={() => {
            setModalShow(false);
            setForgetPasswordModal(true);
          }}
        >
          Forgot Password?
        </button>
      </span>
    </div>
  );
};

function SignInModal({
  modalShow,
  setModalShow,
  setModalShow2,
  setForgetPasswordModal,
  ...props
}) {
  const [loading, setLoading] = useState(false);
  const closeModalHandler = () => setModalShow(false);
  const { handleSignin } = useAuth();
  const { setIsLoggedIn, setUserData } = useContext(UserContext);

 
  const toastOptions = {
    theme: "colored",
    position: "top-center",
    hideProgressBar: true,
  };

  const SignInSchema = Yup.object().shape({
    email: Yup.string().required(),
    password: Yup.string().required(),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    onSubmit(values) {
      setLoading(true);
      handleSignin(values)
        .then(async (res) => {
          setIsLoggedIn(true);
          setUserData(res.data);
          localStorage.setItem(
            "_2mseamlessTailoring",
            JSON.stringify(res.data)
          );
          localStorage.setItem(
            "_2mseamlessTailoring_Profile",
            JSON.stringify(res.data.user)
          );
          toast.success("Logged in successfully!!!", toastOptions);
          setModalShow(false);
          window.location.reload()
        })
        .catch((e) =>
          toast.error("Error: " + e.response.data.error, toastOptions)
        )
        .finally(() => setLoading(false));
    },
    validationSchema: SignInSchema,
  });

  return (
    <Modal
      dialogClassName={"LoginModal"}
      show={modalShow}
      onHide={closeModalHandler}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal-title"
          >
            <h2>Login</h2>
            <p>Welcome back, enter your details to log in</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Input
            placeholder="Enter Email address*"
            {...formik.getFieldProps("email")}
          />
          <PasswordInput
            placeholder="Password*"
            {...formik.getFieldProps("password")}
          />
          <SignInBox {...{ setForgetPasswordModal, setModalShow }} />
          <ButtonContainer disabled={!formik.isValid} className="btn_login">
            {!loading ? (
              "Log In"
            ) : (
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            )}
          </ButtonContainer>

          <div className="account_signup">
            Don't have an account?
            {/* <Link to=""> */}
            {/* <Register
              {...{ setModalShow, setModalShow2, modalShow, modalShow2 }}
            /> */}
            {/* </Link>{" "} */}
            <button
              type="button"
              className="gf_btn"
              onClick={() => {
                setModalShow(false);
                setModalShow2(true);
              }}
            >
              Sign Up
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button onClick={props.onHide}>Close</Button> */}
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default SignInModal;
